import React from 'react';
import './styles/security-list.scss';
import cx from 'classnames';
import hipaa from '../../images/sprites/security-list/hipaa-compliant.png';
import soc2 from '../../images/sprites/security-list/soc2type2.png';
import iso from '../../images/sprites/security-list/iso-certified.png';
import gdpr from '../../images/sprites/security-list/eu-gdpr.png';
import privacyShield from '../../images/sprites/security-list/privacy-shield.png';
import ccpa from '../../images/sprites/security-list/ccpa.png';
import inpdp from '../../images/sprites/security-list/india_idpdpc.webp';

import { t } from '@i18n/i18n';
import securityListTranslations from '@i18n/translations/components/security-list/security-list.json';
import { useI18nInitNamespace } from '../../i18n/useI18nInitNamespace';
import { isEnInBuild } from '../../i18n/environments';
import CloudflareImage from '../cloudflare-image/CloudflareImage';

const SecurityList = ({ additionalClass, margin }) => {
  useI18nInitNamespace('securityList', securityListTranslations, true);
  return (
    <ul style={{ margin: margin && margin }} className={cx('security-list', { 'security-en': isEnInBuild }, additionalClass)}>
      {isEnInBuild && (
        <li>
          <CloudflareImage id="security_img_en" src={inpdp} width="133" height="34" loading="lazy" alt="pdp" decoding="async" />
        </li>
      )}
      <li>
        <CloudflareImage id="security_img_2" src={soc2} width="184" height="56" loading="lazy" alt="soc2" decoding="async" />
      </li>

      <li>
        <CloudflareImage id="security_img_3" src={iso} width="162" height="52" loading="lazy" alt="soc2" decoding="async" />
      </li>

      <li>
        <CloudflareImage id="security_img_hipaa" src={hipaa} width="128" height="67" loading="lazy" alt="hipaa" decoding="async" />
      </li>

      <li>
        <CloudflareImage id="security_img_4" src={gdpr} width="192" height="55" loading="lazy" alt="gdpr" decoding="async" />
      </li>

      <li>
        <CloudflareImage
          id="security_img_5"
          src={privacyShield}
          width="192"
          height="57"
          loading="lazy"
          alt={t('Privacy_shield_alt', true)}
          decoding="async"
        />
      </li>

      <li>
        <CloudflareImage id="security_img_6" src={ccpa} width="184" height="65" loading="lazy" alt="ccpa" decoding="async" />
      </li>
    </ul>
  );
};

export default SecurityList;
